import React from "react";
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const cols = [
    {
      title: "Product",
      links: [
        { label: "Browse Vehicles", href: "/#categories" },
        { label: "Post a Listing", href: "/#download" },
        { label: "Dealer Accounts", href: "/#roles" },
        { label: "Download App", href: "/#download" },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "About Us", href: "/#about" },
        { label: "Careers", href: "/#about" },
        { label: "Blog", href: "/blogs" },
        { label: "Press", href: "/blogs" },
      ],
    },
    {
      title: "Support",
      links: [
        { label: "Help Center", href: "/#faq" },
        { label: "Contact Us", href: "/#faq" },
        { label: "Safety Tips", href: "/#faq" },
        { label: "Report a Listing", href: "/#faq" },
      ],
    },
  ];

  const socialLinks = [

  {
  name: "Instagram",
  href: "https://www.instagram.com/zamwheelz",
  icon: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
  )
},
    {
      name: "Twitter",
      href: "https://twitter.com/zamwheelz",
      icon: <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>
    },
    {
      name: "Download",
      href: "/#download",
      icon: <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-logo">
              Zam<span style={{ color: "var(--primary)" }}>Wheelz</span>
            </h3>
            <p>Zambia's trusted vehicle marketplace. Buy, sell, and deal, all in one app.</p>
            <div className="footer-socials">
              {socialLinks.map((item) => (
                <a
                  className="footer-social"
                  key={item.name}
                  href={item.href}
                  title={item.name}
                  aria-label={item.name}
                  target={item.href.startsWith("http") ? "_blank" : undefined}
                  rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>
          {cols.map((col) => (
            <div className="footer-col" key={col.title}>
              <h4>{col.title}</h4>
              {col.links.map((link) => (
                <a key={link.label} href={link.href}>{link.label}</a>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>© {currentYear} ZamWheelz. All rights reserved.</span>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;